import React, { useEffect, useState } from "react";

import GoogleTranslate from "./GoogleTranslate";
import axios from "axios";

const Home = () => {
  const [content, setContent] = useState(null);

  useEffect(() => {
    (async () => {
      const data = await axios.get("https://dummyjson.com/products");
      setContent(data);
    })();
  }, []);
  console.log("here is content", JSON.stringify(content));
  return (
    <div>
      <GoogleTranslate />
      {content?.data?.products.map((product) => (
        <div key={product.id}>
          <h1>{product.title}</h1>
          <p>{product.description}</p>
        </div>
      ))}
    </div>
  );
};

export default Home;
